export const TAGS_PER_PAGE = 50;
